// officeInvite.actions.js
import axiosInstance from "../helpers/axios";
import { officeInviteConstants as C } from "./constants";

const getError = (error, fallback = "Ошибка запроса") => {
    return error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallback;
};

export const clearOfficeInviteError = () => ({
    type: C.CLEAR_OFFICE_INVITE_ERROR,
});

export const clearPublicOfficeInvite = () => ({
    type: C.CLEAR_PUBLIC_OFFICE_INVITE,
});

export const createOfficeInvite = (officeId, payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.CREATE_OFFICE_INVITE_REQUEST });

            const response = await axiosInstance.post(`/office/${officeId}/invites`, payload);

            dispatch({
                type: C.CREATE_OFFICE_INVITE_SUCCESS,
                payload: {
                    officeId,
                    invite: response.data?.invite,
                    inviteUrl: response.data?.inviteUrl,
                    userExists: response.data?.userExists,
                    message: response.data?.message,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.CREATE_OFFICE_INVITE_FAILURE,
                payload: { error: getError(error, "Ошибка создания приглашения") },
            });

            throw error;
        }
    };
};

export const getOfficeInvites = (officeId) => {
    return async (dispatch) => {
        try {
            if (!officeId || officeId === "all") {
                dispatch({
                    type: C.GET_OFFICE_INVITES_FAILURE,
                    payload: { error: "Выберите конкретный офис" },
                });

                return null;
            }

            dispatch({ type: C.GET_OFFICE_INVITES_REQUEST });

            const response = await axiosInstance.get(`/office/${officeId}/invites`);

            dispatch({
                type: C.GET_OFFICE_INVITES_SUCCESS,
                payload: {
                    officeId,
                    invites: response.data?.invites || [],
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.GET_OFFICE_INVITES_FAILURE,
                payload: { error: getError(error, "Ошибка загрузки приглашений") },
            });

            return null;
        }
    };
};

export const cancelOfficeInvite = (officeId, inviteId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.CANCEL_OFFICE_INVITE_REQUEST });

            const response = await axiosInstance.patch(`/office/${officeId}/invites/${inviteId}/cancel`);

            dispatch({
                type: C.CANCEL_OFFICE_INVITE_SUCCESS,
                payload: {
                    officeId,
                    invite: response.data?.invite,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.CANCEL_OFFICE_INVITE_FAILURE,
                payload: { error: getError(error, "Ошибка отмены приглашения") },
            });

            throw error;
        }
    };
};

export const getOfficeInviteByToken = (token) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.GET_OFFICE_INVITE_BY_TOKEN_REQUEST });

            const response = await axiosInstance.get(`/office-invites/${token}`);

            dispatch({
                type: C.GET_OFFICE_INVITE_BY_TOKEN_SUCCESS,
                payload: {
                    invite: response.data?.invite || null,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.GET_OFFICE_INVITE_BY_TOKEN_FAILURE,
                payload: { error: getError(error, "Ошибка загрузки приглашения") },
            });

            return null;
        }
    };
};

export const acceptOfficeInvite = (token) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.ACCEPT_OFFICE_INVITE_REQUEST });

            const response = await axiosInstance.post(`/office-invites/${token}/accept`);

            dispatch({
                type: C.ACCEPT_OFFICE_INVITE_SUCCESS,
                payload: {
                    invite: response.data?.invite || null,
                    member: response.data?.member || null,
                    message: response.data?.message,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.ACCEPT_OFFICE_INVITE_FAILURE,
                payload: { error: getError(error, "Ошибка принятия приглашения") },
            });

            throw error;
        }
    };
};

export const declineOfficeInvite = (token) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.DECLINE_OFFICE_INVITE_REQUEST });

            const response = await axiosInstance.post(`/office-invites/${token}/decline`);

            dispatch({
                type: C.DECLINE_OFFICE_INVITE_SUCCESS,
                payload: {
                    invite: response.data?.invite || null,
                    message: response.data?.message,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.DECLINE_OFFICE_INVITE_FAILURE,
                payload: { error: getError(error, "Ошибка отклонения приглашения") },
            });

            throw error;
        }
    };
};